import { JQueryHelperService } from './../../shared/models/jquery-helper.service';
import { EventViewerSearchModel } from './event-viewer.model';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class EventViewerService {
  JQueryHelper: JQueryHelperService = new JQueryHelperService();
  constructor(private authService: AuthService, private http: Http) { }

  public GetAuditLogTrailList(searchModel: EventViewerSearchModel): Observable<IAPIResponse> {
    let getAuditLogTrailListUrl = WeGoConfig.API_GET_AUDIT_LOG_TRAIL_LIST;
    let queryString = this.JQueryHelper.Param(searchModel);
    if (queryString) {
      getAuditLogTrailListUrl = getAuditLogTrailListUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getAuditLogTrailListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/event-viewer/models/event-viewer.service.ts